import type { Organisation } from '@shared/modules/organisations/organisation';
import { Presenter } from '@shared/presenters/presenter';

export class OrganisationPresenter extends Presenter<Organisation> {

    get name(): string {
        return this.data.name;
    }

    get email(): string {
        return this.data.email;
    }

}
